import { debounce } from 'vue-debounce';

import CountriesFlags from './countriesFlags';
import CountriesList from './countriesList';


/* eslint quote-props: ["error", "as-needed", { "keywords": true, "unnecessary": false }] */

export default {
  name: 'CountrySelector',

  props: {
    countryCode: String,
  },

  methods: {
    onFormClick() {
      if (this.isDropdownManualyHided) {
        return;
      }

      this.isShowDropdown = true;
      debounce(() => { this.$refs.dropdown.focus(); }, 30)();
    },

    onSelect(data) {
      this.isShowDropdown = false;
      this.input = `+${data.code}`;
      this.$emit('onChange', { 'code': data.code, 'alpha2': data.alpha2 });
    },

    hideDropdown() {
      this.isDropdownManualyHided = true;
      debounce(() => { this.isDropdownManualyHided = false; }, 300)();
      this.isShowDropdown = false;
    },
  },

  data() {
    return {
      input: this.countryCode,
      countriesList: CountriesList,
      countriesFlags: CountriesFlags,
      isShowDropdown: false,
      i18n: this.$i18n,
    };
  },
};
